import NaptimeResource from './NaptimeResource';

class ProductEventInterests extends NaptimeResource {
  static RESOURCE_NAME = 'productEventInterests.v1';
}

export default ProductEventInterests;
